import { defineMessages } from 'react-intl-next';

const _default_1: {
	fieldLevelIndicatorTooltipContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	fieldLevelIndicatorTooltipContent: {
		id: 'issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content',
		defaultMessage: 'Loading UI modifications...',
		description: 'A tooltip message showed on UI modifications loading icon on each loading field',
	},
});
export default _default_1;
